module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv1-94ce350d84f4b755352745efc1ce2b57.jpg";